// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Youtube: React.FC = () => {
    return <svg width="35" height="24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false"><path d="M24.104 23.865l.912-.039c2.266-.105 4.392-.273 5.39-.543 1.469-.395 2.625-1.51 3.018-2.989.618-2.322.7-6.83.712-7.992v-.556c-.011-1.16-.094-5.67-.712-7.992A4.29 4.29 0 0030.406.717c-.998-.27-3.123-.438-5.39-.543l-.912-.039A206.06 206.06 0 0017.533 0h-.928C14.525.01 6.06.088 3.73.717A4.29 4.29 0 00.713 3.754c-.618 2.322-.7 6.831-.711 7.992L0 11.952v.144l.002.206c.01 1.161.093 5.67.711 7.992.393 1.479 1.55 2.594 3.018 2.99 2.33.628 10.794.706 12.874.716h.928c1.07-.005 3.827-.028 6.571-.135zM13.577 17.1V6.948l8.923 5.076-8.923 5.076z" fillRule="nonzero"/></svg>;
};

export default React.memo(Youtube);
